"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useEscapeKeyHandler = function (callback) {
    // Memoize the callback to ensure a stable reference
    var stableCallback = (0, react_1.useCallback)(callback, []);
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            if (event.key === "Escape") {
                stableCallback();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [stableCallback]);
};
exports.default = useEscapeKeyHandler;
